import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthenticationStrategy, AuthenticationResult } from './authentication-strategy.interface';
import { DatabaseService } from '../database.service';
import { firstValueFrom } from 'rxjs';
import { map } from 'rxjs/operators';
import { EnvironmentService } from '../../services/enviroment.service';
import { environment } from '../../services/global-environment';

interface UserAccount {
  username: string;
  password: string;
  modules: string[];
  companyid: string;
  id:string;
}

@Injectable({
  providedIn: 'root'
})
export class DBAuthenticationStrategy implements AuthenticationStrategy {
  private apiUrl = environment.apiUrl;

  constructor(
    private databaseService: DatabaseService,
    private http: HttpClient
  ) {}

  async authenticate(credentials: { username: string; password: string; }): Promise<AuthenticationResult> {
    try {
      // Use dedicated password verification API
      const verifyData = {
        companyid: environment.companyid,
        username: credentials.username,
        password: credentials.password
      };

      const response = await this.http.post<any>(`${this.apiUrl}/api/login/verify_password`, verifyData, {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' })
      }).toPromise();

      if (response && response.success && response.isValid && response.userData) {
        const userData = response.userData;
        return {
          success: true,
          companyid: environment.companyid,
          username: userData.username,
          modules: userData.modules || [],
          id: userData.id
        };
      } else {
        return {
          success: false
        };
      }
    } catch (error) {
      console.error('驗證過程發生錯誤:', error);
      return {
        success: false
      };
    }
  }
}
